const types = {
  SET_NOTIFY_STATUS: 'notify/SET_NOTIFY_STATUS',
};

export default types;
